import { useEffect, useState } from "react"
import { getCustomerList } from "../services/alertGridServices";

export const useCustomer = () => {
    const [customers, setCustomers] = useState([])
    const [customerOptions, setCustomerOptions] = useState([]);

    useEffect(() => {
        getCustomers();
    }, []);

    const getCustomers = () => {
        getCustomerList()
            .then((res) => {
                if (res.Status == "success") {
                    setCustomers(res.Data)
                    let arr = res.Data.map((item) => ({
                        value: item.ClientId,
                        label: item.ClientName
                    }))
                    setCustomerOptions(arr);
                }
            })
            .catch(err => console.log(err))
    }

    return { customers, customerOptions, setCustomers, setCustomerOptions, getCustomers }
}